import {baseTpaMetaData} from './baseTpaMetaData'
export const tpaGluedWidgetMetaData = {
    nickname: baseTpaMetaData.nickname,
    isRepeatable: baseTpaMetaData.isRepeatable,
    isPublicContainer: false,
    fullWidth: false
}
